<script>
  import Heading from '$lib/components/ui/Heading.svelte'
  import Paragraph from '$lib/components/ui/Paragraph.svelte'
  import Section from '$lib/components/ui/Section.svelte'
</script>

<Section spacing="first">
  <Heading>Contact</Heading>

  <Paragraph
    >Have questions or suggestions? We‘d love to hear from you!</Paragraph
  >

  <a class="@button" href="mailto:contact@pausly.app">Send us an email</a>
</Section>
